import React, { useState } from 'react';
import { Table } from '../common';
import Paginator from '../common/tables/Paginator';
import OnPremPortOpeningRequest from '../../models/entities/PortOpeningRequestOnPrem';
import ApprovalsOnPremPORsTableRow from './ApprovalsOnPremPORsTableRow';

interface ApprovalsOnPremPORsTableProps {
    filteredOnPremPORs: OnPremPortOpeningRequest[];
}

const ApprovalsOnPremPORsTable = ({
    filteredOnPremPORs,
}: ApprovalsOnPremPORsTableProps) => {
    const [onPremPorsOnPage, setOnPremPorsOnPage] = useState<OnPremPortOpeningRequest[]>([]);
    return (
        <Table
            firstColumnAlign='center'
            footer={
                <Paginator
                    data={filteredOnPremPORs}
                    onPageChange={(onpremPors: OnPremPortOpeningRequest[]) => {
                        setOnPremPorsOnPage(onpremPors)
                    }}
                />
            }
        >
            <Table.Head>
                <Table.Head.Row>
                    <Table.Head.Cell>OnPremPOR #</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Scope</Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>
                        Status
                    </Table.Head.Cell>
                    <Table.Head.Cell className='em-u-text-align-center'>Action</Table.Head.Cell>
                </Table.Head.Row>
            </Table.Head>
            <Table.Body>
                {onPremPorsOnPage.map((onpremPor: OnPremPortOpeningRequest) => {
                    return <ApprovalsOnPremPORsTableRow
                        key={onpremPor.id}
                        onprempor={onpremPor}
                    />;
                }
                )}
            </Table.Body>
        </Table>
    );
}

export default ApprovalsOnPremPORsTable;